interface TwoLinesProps {
    main: string;
    detail?: string | null;
    /** Alineado a la derecha, para los montos. */
    alignEnd?: boolean;
}

/**
 * Celda de dos líneas de las grillas del reporte: el dato arriba y su detalle abajo, en chico. Entran en los 44 px de
 * la fila (20 + 16 de interlineado). Lo que no entra se corta con "…" y se ve entero en el tooltip.
 */
export default function TwoLines({ main, detail, alignEnd = false }: TwoLinesProps) {
    return (
        <div className={alignEnd ? 'drug-tag-two-lines drug-tag-two-lines--end' : 'drug-tag-two-lines'}>
            <span className="nv-tip" data-pr-tooltip={main}>{main}</span>
            {detail && <span className="nv-help nv-tip" data-pr-tooltip={detail}>{detail}</span>}
        </div>
    );
}
